export const PANEL = {
  SIGN_UP: 'SIGN_UP',
  LOGIN: 'LOGIN',
  COMPLETE_INFO: 'COMPLETE_INFO',
};
